export default "__VITE_ASSET__B7oa2zaL__"